const legalPartnerTranslations = {
  en: {
    navigation: "Legal & Transaction Partners",
    eyebrow: "Panatlantik transaction intelligence",
    title: "Legal & Transaction Partners",
    subtitle: "Verified lawyers, law firms, notaries, solicitors, insolvency professionals and transaction advisers.",
    discover: "Discover professionals",
    addCompany: "Add partner",
    total: "Total partners",
    priorityA: "Priority A",
    verified: "Professionally verified",
    portugal: "Based in Portugal",
    search: "Search professional, office, city or speciality…",
    allCountries: "All countries",
    allRoles: "All professional types",
    allSpecialities: "All specialities",
    allPriorities: "All priorities",
    priority: "Priority",
    portugalPresence: "Portugal presence",
    specialities: "Specialities",
    noDescription: "No professional description recorded.",
    contactMissing: "Professional contact requires verification",
    officialWebsite: "Official website",
    notice: "Internal professional intelligence. Store public professional information only and never privileged client or case details.",
    loading: "Loading legal and transaction partners…",
    loadError: "Legal and transaction partners could not be loaded.",
    noResults: "No legal or transaction partners found.",
    noResultsHelp: "Adjust the filters or discover suitable professionals.",
    form: {
      eyebrow: "Verified professional profile",
      title: "Add Legal or Transaction Partner",
      professionalInformation: "Professional information",
      name: "Partner or firm name",
      legalName: "Legal name",
      partnerType: "Professional type",
      speciality: "Speciality",
      service: "Primary service",
      priority: "Priority",
      country: "Country",
      city: "City",
      website: "Official website",
      professionalBody: "Professional body",
      registrationNumber: "Registration number",
      registryUrl: "Professional registry URL",
      languages: "Languages (comma separated)",
      description: "Professional description",
      professionalContact: "Public professional contact",
      contactName: "Contact name or department",
      jobTitle: "Position",
      email: "Professional email",
      phone: "Telephone",
      contactSource: "Public contact source URL",
      relevance: "Why this professional is relevant",
      privacyNotice: "Store public professional information only. Never enter privileged client communications or confidential case details.",
      saving: "Saving…",
      save: "Save partner",
      created: "Legal and transaction partner created successfully.",
      createError: "Legal or transaction partner could not be created.",
    },
    discovery: {
      back: "Back to Legal & Transaction Partners",
      eyebrow: "Controlled public-source research",
      title: "Discover Legal & Transaction Partners",
      subtitle: "Search official and professional sources, review public contact details and import only complete records.",
      searchPlaceholder: "Professional, office or legal speciality",
      country: "Country",
      partnerType: "Professional type",
      allPartnerTypes: "All professional types",
      service: "Required service",
      allServices: "All services",
      officialUrl: "Known official website (optional)",
      search: "Search sources",
      searching: "Searching…",
      contactReady: "Contact complete",
      needsContact: "Contact missing",
      email: "Reviewed email",
      phone: "Reviewed telephone",
      reviewSource: "Review source",
      imported: "Already imported",
      importing: "Importing…",
      import: "Import professional",
      searchError: "Professional discovery failed.",
      importSuccess: "Professional imported for review.",
      importError: "Professional could not be imported.",
      ruleOfficial: "Review the official website and professional registry before importing.",
      ruleContact: "Public professional email and telephone are mandatory for every imported record.",
      ruleReview: "Discovered information remains unverified until reviewed by an authorised user.",
      results: "professional candidates found",
      provider: "Provider",
      noResults: "No suitable official professional records were found.",
    },
  },
  pt: {
    navigation: "Parceiros Jurídicos e de Transação",
    eyebrow: "Inteligência de transações Panatlantik",
    title: "Parceiros Jurídicos e de Transação",
    subtitle: "Advogados, sociedades de advogados, notários, solicitadores, administradores de insolvência e consultores de transação verificados.",
    discover: "Descobrir profissionais",
    addCompany: "Adicionar parceiro",
    total: "Total de parceiros",
    priorityA: "Prioridade A",
    verified: "Verificados profissionalmente",
    portugal: "Sediados em Portugal",
    search: "Pesquisar profissional, escritório, cidade ou especialidade…",
    allCountries: "Todos os países",
    allRoles: "Todos os tipos profissionais",
    allSpecialities: "Todas as especialidades",
    allPriorities: "Todas as prioridades",
    priority: "Prioridade",
    portugalPresence: "Presença em Portugal",
    specialities: "Especialidades",
    noDescription: "Sem descrição profissional registada.",
    contactMissing: "O contacto profissional requer verificação",
    officialWebsite: "Website oficial",
    notice: "Inteligência profissional interna. Guardar apenas informação profissional pública e nunca dados privilegiados de clientes ou processos.",
    loading: "A carregar parceiros jurídicos e de transação…",
    loadError: "Não foi possível carregar os parceiros jurídicos e de transação.",
    noResults: "Não foram encontrados parceiros jurídicos ou de transação.",
    noResultsHelp: "Ajuste os filtros ou descubra profissionais adequados.",
    form: {
      eyebrow: "Perfil profissional verificado",
      title: "Adicionar Parceiro Jurídico ou de Transação",
      professionalInformation: "Informação profissional",
      name: "Nome do profissional ou sociedade",
      legalName: "Denominação legal",
      partnerType: "Tipo profissional",
      speciality: "Especialidade",
      service: "Serviço principal",
      priority: "Prioridade",
      country: "País",
      city: "Cidade",
      website: "Website oficial",
      professionalBody: "Ordem ou organismo profissional",
      registrationNumber: "Número de inscrição",
      registryUrl: "URL do registo profissional",
      languages: "Idiomas (separados por vírgulas)",
      description: "Descrição profissional",
      professionalContact: "Contacto profissional público",
      contactName: "Nome do contacto ou departamento",
      jobTitle: "Cargo",
      email: "Email profissional",
      phone: "Telefone",
      contactSource: "URL da fonte pública do contacto",
      relevance: "Por que este profissional é relevante",
      privacyNotice: "Guardar apenas informação profissional pública. Nunca introduzir comunicações protegidas com clientes nem detalhes confidenciais de processos.",
      saving: "A guardar…",
      save: "Guardar parceiro",
      created: "Parceiro jurídico e de transação criado com sucesso.",
      createError: "Não foi possível criar o parceiro jurídico ou de transação.",
    },
    discovery: {
      back: "Voltar aos Parceiros Jurídicos e de Transação",
      eyebrow: "Pesquisa controlada em fontes públicas",
      title: "Descobrir Parceiros Jurídicos e de Transação",
      subtitle: "Pesquisar fontes oficiais e profissionais, rever os contactos públicos e importar apenas registos completos.",
      searchPlaceholder: "Profissional, escritório ou especialidade jurídica",
      country: "País",
      partnerType: "Tipo profissional",
      allPartnerTypes: "Todos os tipos profissionais",
      service: "Serviço necessário",
      allServices: "Todos os serviços",
      officialUrl: "Website oficial conhecido (opcional)",
      search: "Pesquisar fontes",
      searching: "A pesquisar…",
      contactReady: "Contacto completo",
      needsContact: "Contacto em falta",
      email: "Email revisto",
      phone: "Telefone revisto",
      reviewSource: "Rever fonte",
      imported: "Já importado",
      importing: "A importar…",
      import: "Importar profissional",
      searchError: "A pesquisa de profissionais falhou.",
      importSuccess: "Profissional importado para revisão.",
      importError: "Não foi possível importar o profissional.",
      ruleOfficial: "Rever o website oficial e o registo profissional antes da importação.",
      ruleContact: "O email e telefone profissionais públicos são obrigatórios em cada registo importado.",
      ruleReview: "A informação descoberta permanece não verificada até ser revista por um utilizador autorizado.",
      results: "profissionais candidatos encontrados",
      provider: "Fornecedor",
      noResults: "Não foram encontrados registos profissionais oficiais adequados.",
    },
  },
};


legalPartnerTranslations.zh = {
  navigation: "法律与交易合作伙伴",
  eyebrow: "Panatlantik交易情报",
  title: "法律与交易合作伙伴",
  subtitle: "经核验的律师、律师事务所、公证员、法律事务代理人、破产管理人及交易顾问。",
  discover: "发现专业人士",
  addCompany: "添加合作伙伴",
  total: "合作伙伴总数",
  priorityA: "A级优先",
  verified: "专业资质已验证",
  portugal: "位于葡萄牙",
  search: "搜索专业人士、事务所、城市或专业领域…",
  allCountries: "所有国家",
  allRoles: "所有专业类型",
  allSpecialities: "所有专业领域",
  allPriorities: "所有优先级",
  priority: "优先级",
  portugalPresence: "葡萄牙业务",
  specialities: "专业领域",
  noDescription: "尚未记录专业简介。",
  contactMissing: "专业联系信息需要验证",
  officialWebsite: "官方网站",
  notice: "内部专业情报。仅保存公开的专业信息，绝不保存受保密特权保护的客户信息或案件详情。",
  loading: "正在加载法律与交易合作伙伴…",
  loadError: "无法加载法律与交易合作伙伴。",
  noResults: "未找到法律或交易合作伙伴。",
  noResultsHelp: "请调整筛选条件或发现合适的专业人士。",
  form: {
    eyebrow: "已验证的专业档案",
    title: "添加法律或交易合作伙伴",
    professionalInformation: "专业信息",
    name: "专业人士或事务所名称",
    legalName: "法定名称",
    partnerType: "专业类型",
    speciality: "专业领域",
    service: "主要服务",
    priority: "优先级",
    country: "国家",
    city: "城市",
    website: "官方网站",
    professionalBody: "专业机构",
    registrationNumber: "注册编号",
    registryUrl: "专业注册页面网址",
    languages: "语言（用逗号分隔）",
    description: "专业简介",
    professionalContact: "公开专业联系人",
    contactName: "联系人或部门名称",
    jobTitle: "职位",
    email: "专业电子邮箱",
    phone: "电话",
    contactSource: "公开联系信息来源网址",
    relevance: "该专业人士为何具有相关性",
    privacyNotice: "仅保存公开专业信息。切勿输入受保密特权保护的客户通信或机密案件详情。",
    saving: "正在保存…",
    save: "保存合作伙伴",
    created: "法律与交易合作伙伴创建成功。",
    createError: "无法创建法律或交易合作伙伴。",
  },
  discovery: {
    back: "返回法律与交易合作伙伴",
    eyebrow: "受控公开来源研究",
    title: "发现法律与交易合作伙伴",
    subtitle: "搜索官方及专业来源，审核公开联系信息，并仅导入资料完整的记录。",
    searchPlaceholder: "专业人士、事务所或法律专业领域",
    country: "国家",
    partnerType: "专业类型",
    allPartnerTypes: "所有专业类型",
    service: "所需服务",
    allServices: "所有服务",
    officialUrl: "已知官方网站（可选）",
    search: "搜索来源",
    searching: "正在搜索…",
    contactReady: "联系信息完整",
    needsContact: "缺少联系信息",
    email: "已审核邮箱",
    phone: "已审核电话",
    reviewSource: "审核来源",
    imported: "已导入",
    importing: "正在导入…",
    import: "导入专业人士",
    searchError: "专业人士搜索失败。",
    importSuccess: "专业人士已导入并等待审核。",
    importError: "无法导入该专业人士。",
    ruleOfficial: "导入前审核官方网站及专业注册信息。",
    ruleContact: "每条导入记录都必须提供公开的专业邮箱和电话。",
    ruleReview: "发现的信息在授权用户审核前均保持未验证状态。",
    results: "名候选专业人士已找到",
    provider: "搜索服务商",
    noResults: "未找到合适的官方专业记录。",
  },
};

legalPartnerTranslations.fr = {
  navigation: "Partenaires Juridiques et Transactionnels",
  eyebrow: "Intelligence transactionnelle Panatlantik",
  title: "Partenaires Juridiques et Transactionnels",
  subtitle: "Avocats, cabinets, notaires, professionnels du droit, administrateurs d’insolvabilité et conseillers transactionnels vérifiés.",
  discover: "Découvrir des professionnels",
  addCompany: "Ajouter un partenaire",
  total: "Total des partenaires",
  priorityA: "Priorité A",
  verified: "Vérifiés professionnellement",
  portugal: "Établis au Portugal",
  search: "Rechercher un professionnel, cabinet, ville ou spécialité…",
  allCountries: "Tous les pays",
  allRoles: "Tous les types professionnels",
  allSpecialities: "Toutes les spécialités",
  allPriorities: "Toutes les priorités",
  priority: "Priorité",
  portugalPresence: "Présence au Portugal",
  specialities: "Spécialités",
  noDescription: "Aucune description professionnelle enregistrée.",
  contactMissing: "Le contact professionnel doit être vérifié",
  officialWebsite: "Site officiel",
  notice: "Intelligence professionnelle interne. Enregistrer uniquement des informations professionnelles publiques, jamais de données privilégiées concernant des clients ou dossiers.",
  loading: "Chargement des partenaires juridiques et transactionnels…",
  loadError: "Impossible de charger les partenaires juridiques et transactionnels.",
  noResults: "Aucun partenaire juridique ou transactionnel trouvé.",
  noResultsHelp: "Ajustez les filtres ou recherchez des professionnels appropriés.",
  form: {
    eyebrow: "Profil professionnel vérifié",
    title: "Ajouter un Partenaire Juridique ou Transactionnel",
    professionalInformation: "Informations professionnelles",
    name: "Nom du professionnel ou du cabinet",
    legalName: "Dénomination légale",
    partnerType: "Type professionnel",
    speciality: "Spécialité",
    service: "Service principal",
    priority: "Priorité",
    country: "Pays",
    city: "Ville",
    website: "Site officiel",
    professionalBody: "Ordre ou organisme professionnel",
    registrationNumber: "Numéro d’inscription",
    registryUrl: "URL du registre professionnel",
    languages: "Langues (séparées par des virgules)",
    description: "Description professionnelle",
    professionalContact: "Contact professionnel public",
    contactName: "Nom du contact ou du service",
    jobTitle: "Fonction",
    email: "E-mail professionnel",
    phone: "Téléphone",
    contactSource: "URL de la source publique du contact",
    relevance: "Pourquoi ce professionnel est pertinent",
    privacyNotice: "Enregistrer uniquement des informations professionnelles publiques. Ne jamais saisir de communications client protégées ni de détails confidentiels de dossiers.",
    saving: "Enregistrement…",
    save: "Enregistrer le partenaire",
    created: "Partenaire juridique et transactionnel créé avec succès.",
    createError: "Impossible de créer le partenaire juridique ou transactionnel.",
  },
  discovery: {
    back: "Retour aux Partenaires Juridiques et Transactionnels",
    eyebrow: "Recherche contrôlée dans les sources publiques",
    title: "Découvrir des Partenaires Juridiques et Transactionnels",
    subtitle: "Rechercher les sources officielles et professionnelles, vérifier les contacts publics et importer uniquement les dossiers complets.",
    searchPlaceholder: "Professionnel, cabinet ou spécialité juridique",
    country: "Pays",
    partnerType: "Type professionnel",
    allPartnerTypes: "Tous les types professionnels",
    service: "Service requis",
    allServices: "Tous les services",
    officialUrl: "Site officiel connu (facultatif)",
    search: "Rechercher les sources",
    searching: "Recherche en cours…",
    contactReady: "Contact complet",
    needsContact: "Contact manquant",
    email: "E-mail vérifié",
    phone: "Téléphone vérifié",
    reviewSource: "Vérifier la source",
    imported: "Déjà importé",
    importing: "Importation…",
    import: "Importer le professionnel",
    searchError: "La recherche de professionnels a échoué.",
    importSuccess: "Professionnel importé pour vérification.",
    importError: "Impossible d’importer le professionnel.",
    ruleOfficial: "Vérifier le site officiel et le registre professionnel avant l’importation.",
    ruleContact: "L’e-mail et le téléphone professionnels publics sont obligatoires pour chaque dossier importé.",
    ruleReview: "Les informations découvertes restent non vérifiées jusqu’à leur examen par un utilisateur autorisé.",
    results: "professionnels candidats trouvés",
    provider: "Fournisseur",
    noResults: "Aucun dossier professionnel officiel approprié n’a été trouvé.",
  },
};


legalPartnerTranslations.es = {
  navigation: "Socios Jurídicos y de Transacción",
  eyebrow: "Inteligencia transaccional Panatlantik",
  title: "Socios Jurídicos y de Transacción",
  subtitle: "Abogados, bufetes, notarios, profesionales jurídicos, administradores concursales y asesores de transacciones verificados.",
  discover: "Descubrir profesionales",
  addCompany: "Añadir socio",
  total: "Total de socios",
  priorityA: "Prioridad A",
  verified: "Verificados profesionalmente",
  portugal: "Establecidos en Portugal",
  search: "Buscar profesional, despacho, ciudad o especialidad…",
  allCountries: "Todos los países",
  allRoles: "Todos los tipos profesionales",
  allSpecialities: "Todas las especialidades",
  allPriorities: "Todas las prioridades",
  priority: "Prioridad",
  portugalPresence: "Presencia en Portugal",
  specialities: "Especialidades",
  noDescription: "No hay descripción profesional registrada.",
  contactMissing: "El contacto profesional requiere verificación",
  officialWebsite: "Sitio oficial",
  notice: "Inteligencia profesional interna. Guardar únicamente información profesional pública y nunca datos privilegiados de clientes o expedientes.",
  loading: "Cargando socios jurídicos y de transacción…",
  loadError: "No se pudieron cargar los socios jurídicos y de transacción.",
  noResults: "No se encontraron socios jurídicos o de transacción.",
  noResultsHelp: "Ajuste los filtros o busque profesionales adecuados.",
  form: {
    eyebrow: "Perfil profesional verificado",
    title: "Añadir Socio Jurídico o de Transacción",
    professionalInformation: "Información profesional",
    name: "Nombre del profesional o despacho",
    legalName: "Razón social",
    partnerType: "Tipo profesional",
    speciality: "Especialidad",
    service: "Servicio principal",
    priority: "Prioridad",
    country: "País",
    city: "Ciudad",
    website: "Sitio web oficial",
    professionalBody: "Colegio u organismo profesional",
    registrationNumber: "Número de colegiación",
    registryUrl: "URL del registro profesional",
    languages: "Idiomas (separados por comas)",
    description: "Descripción profesional",
    professionalContact: "Contacto profesional público",
    contactName: "Nombre del contacto o departamento",
    jobTitle: "Cargo",
    email: "Correo profesional",
    phone: "Teléfono",
    contactSource: "URL de la fuente pública del contacto",
    relevance: "Por qué este profesional es relevante",
    privacyNotice: "Guardar únicamente información profesional pública. Nunca introducir comunicaciones protegidas de clientes ni detalles confidenciales de expedientes.",
    saving: "Guardando…",
    save: "Guardar socio",
    created: "Socio jurídico y de transacción creado correctamente.",
    createError: "No se pudo crear el socio jurídico o de transacción.",
  },
  discovery: {
    back: "Volver a Socios Jurídicos y de Transacción",
    eyebrow: "Investigación controlada en fuentes públicas",
    title: "Descubrir Socios Jurídicos y de Transacción",
    subtitle: "Buscar fuentes oficiales y profesionales, revisar los contactos públicos e importar únicamente registros completos.",
    searchPlaceholder: "Profesional, despacho o especialidad jurídica",
    country: "País",
    partnerType: "Tipo profesional",
    allPartnerTypes: "Todos los tipos profesionales",
    service: "Servicio requerido",
    allServices: "Todos los servicios",
    officialUrl: "Sitio oficial conocido (opcional)",
    search: "Buscar fuentes",
    searching: "Buscando…",
    contactReady: "Contacto completo",
    needsContact: "Falta contacto",
    email: "Correo revisado",
    phone: "Teléfono revisado",
    reviewSource: "Revisar fuente",
    imported: "Ya importado",
    importing: "Importando…",
    import: "Importar profesional",
    searchError: "La búsqueda de profesionales ha fallado.",
    importSuccess: "Profesional importado para revisión.",
    importError: "No se pudo importar el profesional.",
    ruleOfficial: "Revisar el sitio oficial y el registro profesional antes de importar.",
    ruleContact: "El correo y teléfono profesionales públicos son obligatorios en cada registro importado.",
    ruleReview: "La información descubierta permanece sin verificar hasta su revisión por un usuario autorizado.",
    results: "profesionales candidatos encontrados",
    provider: "Proveedor",
    noResults: "No se encontraron registros profesionales oficiales adecuados.",
  },
};

legalPartnerTranslations.de = {
  navigation: "Rechts- und Transaktionspartner",
  eyebrow: "Panatlantik-Transaktionsinformationen",
  title: "Rechts- und Transaktionspartner",
  subtitle: "Verifizierte Rechtsanwälte, Kanzleien, Notare, Insolvenzverwalter und Transaktionsberater.",
  discover: "Fachleute entdecken",
  addCompany: "Partner hinzufügen",
  total: "Partner insgesamt",
  priorityA: "Priorität A",
  verified: "Beruflich verifiziert",
  portugal: "Mit Sitz in Portugal",
  search: "Fachperson, Kanzlei, Stadt oder Fachgebiet suchen…",
  allCountries: "Alle Länder",
  allRoles: "Alle Berufsarten",
  allSpecialities: "Alle Fachgebiete",
  allPriorities: "Alle Prioritäten",
  priority: "Priorität",
  portugalPresence: "Präsenz in Portugal",
  specialities: "Fachgebiete",
  noDescription: "Keine berufliche Beschreibung erfasst.",
  contactMissing: "Der berufliche Kontakt muss verifiziert werden",
  officialWebsite: "Offizielle Website",
  notice: "Interne Fachinformationen. Nur öffentliche berufliche Informationen speichern, niemals privilegierte Mandanten- oder Falldaten.",
  loading: "Rechts- und Transaktionspartner werden geladen…",
  loadError: "Rechts- und Transaktionspartner konnten nicht geladen werden.",
  noResults: "Keine Rechts- oder Transaktionspartner gefunden.",
  noResultsHelp: "Filter anpassen oder geeignete Fachleute suchen.",
  form: {
    eyebrow: "Verifiziertes Berufsprofil",
    title: "Rechts- oder Transaktionspartner hinzufügen",
    professionalInformation: "Berufliche Informationen",
    name: "Name der Fachperson oder Kanzlei",
    legalName: "Rechtlicher Name",
    partnerType: "Berufsart",
    speciality: "Fachgebiet",
    service: "Hauptleistung",
    priority: "Priorität",
    country: "Land",
    city: "Stadt",
    website: "Offizielle Website",
    professionalBody: "Berufsverband oder Kammer",
    registrationNumber: "Registrierungsnummer",
    registryUrl: "URL des Berufsregisters",
    languages: "Sprachen (durch Kommas getrennt)",
    description: "Berufliche Beschreibung",
    professionalContact: "Öffentlicher Geschäftskontakt",
    contactName: "Kontaktperson oder Abteilung",
    jobTitle: "Position",
    email: "Geschäftliche E-Mail",
    phone: "Telefon",
    contactSource: "URL der öffentlichen Kontaktquelle",
    relevance: "Warum diese Fachperson relevant ist",
    privacyNotice: "Nur öffentliche berufliche Informationen speichern. Niemals geschützte Mandantenkommunikation oder vertrauliche Falldetails eingeben.",
    saving: "Wird gespeichert…",
    save: "Partner speichern",
    created: "Rechts- und Transaktionspartner erfolgreich erstellt.",
    createError: "Der Rechts- oder Transaktionspartner konnte nicht erstellt werden.",
  },
  discovery: {
    back: "Zurück zu Rechts- und Transaktionspartnern",
    eyebrow: "Kontrollierte Recherche in öffentlichen Quellen",
    title: "Rechts- und Transaktionspartner entdecken",
    subtitle: "Offizielle und berufliche Quellen durchsuchen, öffentliche Kontaktdaten prüfen und nur vollständige Datensätze importieren.",
    searchPlaceholder: "Fachperson, Kanzlei oder Rechtsgebiet",
    country: "Land",
    partnerType: "Berufsart",
    allPartnerTypes: "Alle Berufsarten",
    service: "Benötigte Leistung",
    allServices: "Alle Leistungen",
    officialUrl: "Bekannte offizielle Website (optional)",
    search: "Quellen durchsuchen",
    searching: "Suche läuft…",
    contactReady: "Kontakt vollständig",
    needsContact: "Kontakt fehlt",
    email: "Geprüfte E-Mail",
    phone: "Geprüfte Telefonnummer",
    reviewSource: "Quelle prüfen",
    imported: "Bereits importiert",
    importing: "Wird importiert…",
    import: "Fachperson importieren",
    searchError: "Die Suche nach Fachleuten ist fehlgeschlagen.",
    importSuccess: "Fachperson zur Prüfung importiert.",
    importError: "Die Fachperson konnte nicht importiert werden.",
    ruleOfficial: "Offizielle Website und Berufsregister vor dem Import prüfen.",
    ruleContact: "Öffentliche geschäftliche E-Mail und Telefonnummer sind für jeden importierten Datensatz erforderlich.",
    ruleReview: "Gefundene Informationen bleiben bis zur Prüfung durch einen autorisierten Benutzer unverifiziert.",
    results: "potenzielle Fachleute gefunden",
    provider: "Suchanbieter",
    noResults: "Keine geeigneten offiziellen Berufsdatensätze gefunden.",
  },
};


legalPartnerTranslations.it = {
  navigation: "Partner Legali e Transazionali",
  eyebrow: "Intelligence transazionale Panatlantik",
  title: "Partner Legali e Transazionali",
  subtitle: "Avvocati, studi legali, notai, professionisti legali, amministratori d’insolvenza e consulenti transazionali verificati.",
  discover: "Scopri professionisti",
  addCompany: "Aggiungi partner",
  total: "Totale partner",
  priorityA: "Priorità A",
  verified: "Verificati professionalmente",
  portugal: "Con sede in Portogallo",
  search: "Cerca professionista, studio, città o specializzazione…",
  allCountries: "Tutti i paesi",
  allRoles: "Tutti i tipi professionali",
  allSpecialities: "Tutte le specializzazioni",
  allPriorities: "Tutte le priorità",
  priority: "Priorità",
  portugalPresence: "Presenza in Portogallo",
  specialities: "Specializzazioni",
  noDescription: "Nessuna descrizione professionale registrata.",
  contactMissing: "Il contatto professionale richiede verifica",
  officialWebsite: "Sito ufficiale",
  notice: "Intelligence professionale interna. Conservare soltanto informazioni professionali pubbliche, mai dati privilegiati di clienti o pratiche.",
  loading: "Caricamento dei partner legali e transazionali…",
  loadError: "Impossibile caricare i partner legali e transazionali.",
  noResults: "Nessun partner legale o transazionale trovato.",
  noResultsHelp: "Modifica i filtri o cerca professionisti adeguati.",
  form: {
    eyebrow: "Profilo professionale verificato",
    title: "Aggiungi Partner Legale o Transazionale",
    professionalInformation: "Informazioni professionali",
    name: "Nome del professionista o dello studio",
    legalName: "Denominazione legale",
    partnerType: "Tipo professionale",
    speciality: "Specializzazione",
    service: "Servizio principale",
    priority: "Priorità",
    country: "Paese",
    city: "Città",
    website: "Sito ufficiale",
    professionalBody: "Ordine o organismo professionale",
    registrationNumber: "Numero di iscrizione",
    registryUrl: "URL del registro professionale",
    languages: "Lingue (separate da virgole)",
    description: "Descrizione professionale",
    professionalContact: "Contatto professionale pubblico",
    contactName: "Nome del contatto o reparto",
    jobTitle: "Ruolo",
    email: "E-mail professionale",
    phone: "Telefono",
    contactSource: "URL della fonte pubblica del contatto",
    relevance: "Perché questo professionista è rilevante",
    privacyNotice: "Conservare soltanto informazioni professionali pubbliche. Non inserire mai comunicazioni protette dei clienti o dettagli riservati delle pratiche.",
    saving: "Salvataggio…",
    save: "Salva partner",
    created: "Partner legale e transazionale creato con successo.",
    createError: "Impossibile creare il partner legale o transazionale.",
  },
  discovery: {
    back: "Torna ai Partner Legali e Transazionali",
    eyebrow: "Ricerca controllata su fonti pubbliche",
    title: "Scopri Partner Legali e Transazionali",
    subtitle: "Cerca fonti ufficiali e professionali, verifica i contatti pubblici e importa soltanto record completi.",
    searchPlaceholder: "Professionista, studio o specializzazione legale",
    country: "Paese",
    partnerType: "Tipo professionale",
    allPartnerTypes: "Tutti i tipi professionali",
    service: "Servizio richiesto",
    allServices: "Tutti i servizi",
    officialUrl: "Sito ufficiale conosciuto (facoltativo)",
    search: "Cerca fonti",
    searching: "Ricerca in corso…",
    contactReady: "Contatto completo",
    needsContact: "Contatto mancante",
    email: "E-mail verificata",
    phone: "Telefono verificato",
    reviewSource: "Verifica fonte",
    imported: "Già importato",
    importing: "Importazione…",
    import: "Importa professionista",
    searchError: "La ricerca dei professionisti non è riuscita.",
    importSuccess: "Professionista importato per la verifica.",
    importError: "Impossibile importare il professionista.",
    ruleOfficial: "Verificare il sito ufficiale e il registro professionale prima dell’importazione.",
    ruleContact: "E-mail e telefono professionali pubblici sono obbligatori per ogni record importato.",
    ruleReview: "Le informazioni trovate rimangono non verificate fino alla revisione da parte di un utente autorizzato.",
    results: "professionisti candidati trovati",
    provider: "Fornitore",
    noResults: "Nessun record professionale ufficiale adeguato trovato.",
  },
};

legalPartnerTranslations.ru = {
  navigation: "Юридические и Транзакционные Партнёры",
  eyebrow: "Транзакционная аналитика Panatlantik",
  title: "Юридические и Транзакционные Партнёры",
  subtitle: "Проверенные юристы, адвокатские бюро, нотариусы, специалисты по банкротству и консультанты по сделкам.",
  discover: "Найти специалистов",
  addCompany: "Добавить партнёра",
  total: "Всего партнёров",
  priorityA: "Приоритет A",
  verified: "Профессионально проверены",
  portugal: "Находятся в Португалии",
  search: "Поиск специалиста, офиса, города или специализации…",
  allCountries: "Все страны",
  allRoles: "Все профессиональные типы",
  allSpecialities: "Все специализации",
  allPriorities: "Все приоритеты",
  priority: "Приоритет",
  portugalPresence: "Присутствие в Португалии",
  specialities: "Специализации",
  noDescription: "Профессиональное описание отсутствует.",
  contactMissing: "Профессиональный контакт требует проверки",
  officialWebsite: "Официальный сайт",
  notice: "Внутренняя профессиональная аналитика. Хранить только публичную профессиональную информацию, без конфиденциальных данных клиентов или дел.",
  loading: "Загрузка юридических и транзакционных партнёров…",
  loadError: "Не удалось загрузить юридических и транзакционных партнёров.",
  noResults: "Юридические или транзакционные партнёры не найдены.",
  noResultsHelp: "Измените фильтры или найдите подходящих специалистов.",
  form: {
    eyebrow: "Проверенный профессиональный профиль",
    title: "Добавить Юридического или Транзакционного Партнёра",
    professionalInformation: "Профессиональная информация",
    name: "Имя специалиста или название фирмы",
    legalName: "Юридическое наименование",
    partnerType: "Профессиональный тип",
    speciality: "Специализация",
    service: "Основная услуга",
    priority: "Приоритет",
    country: "Страна",
    city: "Город",
    website: "Официальный сайт",
    professionalBody: "Профессиональная палата или организация",
    registrationNumber: "Регистрационный номер",
    registryUrl: "URL профессионального реестра",
    languages: "Языки (через запятую)",
    description: "Профессиональное описание",
    professionalContact: "Публичный профессиональный контакт",
    contactName: "Имя контакта или отдел",
    jobTitle: "Должность",
    email: "Профессиональная электронная почта",
    phone: "Телефон",
    contactSource: "URL публичного источника контакта",
    relevance: "Почему этот специалист актуален",
    privacyNotice: "Хранить только публичную профессиональную информацию. Никогда не вводить защищённые сообщения клиентов или конфиденциальные сведения о делах.",
    saving: "Сохранение…",
    save: "Сохранить партнёра",
    created: "Юридический и транзакционный партнёр успешно создан.",
    createError: "Не удалось создать юридического или транзакционного партнёра.",
  },
  discovery: {
    back: "Назад к Юридическим и Транзакционным Партнёрам",
    eyebrow: "Контролируемый поиск по открытым источникам",
    title: "Поиск Юридических и Транзакционных Партнёров",
    subtitle: "Ищите официальные и профессиональные источники, проверяйте публичные контакты и импортируйте только полные записи.",
    searchPlaceholder: "Специалист, фирма или юридическая специализация",
    country: "Страна",
    partnerType: "Профессиональный тип",
    allPartnerTypes: "Все профессиональные типы",
    service: "Необходимая услуга",
    allServices: "Все услуги",
    officialUrl: "Известный официальный сайт (необязательно)",
    search: "Искать источники",
    searching: "Поиск…",
    contactReady: "Контактные данные полные",
    needsContact: "Контактные данные отсутствуют",
    email: "Проверенная почта",
    phone: "Проверенный телефон",
    reviewSource: "Проверить источник",
    imported: "Уже импортирован",
    importing: "Импорт…",
    import: "Импортировать специалиста",
    searchError: "Поиск специалистов завершился ошибкой.",
    importSuccess: "Специалист импортирован для проверки.",
    importError: "Не удалось импортировать специалиста.",
    ruleOfficial: "Проверьте официальный сайт и профессиональный реестр перед импортом.",
    ruleContact: "Публичная профессиональная почта и телефон обязательны для каждой импортируемой записи.",
    ruleReview: "Найденная информация остаётся непроверенной до проверки уполномоченным пользователем.",
    results: "профессиональных кандидатов найдено",
    provider: "Поставщик поиска",
    noResults: "Подходящие официальные профессиональные записи не найдены.",
  },
};

export default legalPartnerTranslations;
